export const TOKEN_KEY = "auth_token"
export const USER_KEY = "user"
export const USER_ID_KEY = "user_id"
export const GROUPS_KEY = "groups"
export const EMPLOYE_ID_KEY = "employe_id"
export const MUST_CHANGE_KEY = "must_change_password"

export const authStorage = {
	getToken: () => localStorage.getItem(TOKEN_KEY),
	setToken: (token) => localStorage.setItem(TOKEN_KEY, token),
	getUser: () => localStorage.getItem(USER_KEY),
	setUser: (user) => localStorage.setItem(USER_KEY, user),
	getUserId: () => localStorage.getItem(USER_ID_KEY),
	setUserId: (userId) => localStorage.setItem(USER_ID_KEY, userId),
	getGroups: () => JSON.parse(localStorage.getItem(GROUPS_KEY)),
	setGroups: (groups) =>
		localStorage.setItem(GROUPS_KEY, JSON.stringify(groups)),
	getEmployeId: () => parseInt(localStorage.getItem(EMPLOYE_ID_KEY)),
	setEmployeId: (employeId) =>
		localStorage.setItem(EMPLOYE_ID_KEY, employeId),
	getMustChangePassword: () =>
		localStorage.getItem(MUST_CHANGE_KEY) === "true",
	setMustChangePassword: (val) =>
		localStorage.setItem(MUST_CHANGE_KEY, val ? "true" : "false"),
	clear: () => {
		localStorage.removeItem(TOKEN_KEY)
		localStorage.removeItem(USER_KEY)
		localStorage.removeItem(GROUPS_KEY)
		localStorage.removeItem(MUST_CHANGE_KEY)
	},
}

export const isTokenValid = (token) => {
	if (!token) return false

	try {
		const payload = JSON.parse(atob(token.split(".")[1]))
		const now = Date.now() / 1000 // en secondes
		return payload.exp > now
	} catch (e) {
		return false
	}
}
